<template>
  <div>
    <BaseTable
      class="table-shadow"
      :headers="headers"
      :items="info"
      :loading="loading"
      :paginate="true"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      item-key="id_colaborador"
      show-expand
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Consulta</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>

          <RegisterBottom
            v-can-access="572"
            @click="(dialog = true), (labelBtn = 'Salvar')"
          />
          <FilterMetaIndividual
            @selectedFilters="fetchMetaIndividual((filters = $event))"
          />
        </v-toolbar>
      </template>

      <template v-slot:[`item.id_band`]="{ item }">
        <BaseSegmento :segmento="item.id_band" />
      </template>
      <template v-slot:[`item.colaborador`]="{ item }">
        {{ item.id_colaborador }} - {{ item.colaborador | TitleCase }}
      </template>
      <template v-slot:[`item.funcao`]="{ item }">
        {{ item.funcao | TitleCase }}
      </template>

      <template v-slot:[`item.mes_ref`]="{ item }">
        {{ `${item.mes_ref}/${item.ano_ref}` }}
      </template>

      <template v-slot:[`item.qtd_indicadores`]="{ item }">
        {{ item.dados.length }}
      </template>

      <!-- expanded -->

      <template v-slot:[`item.data-table-expand`]="{ expand, isExpanded }">
        <v-btn small text v-if="!isExpanded" @click="expand(!isExpanded)">
          expandir
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
        <v-btn text small v-else @click="expand(!isExpanded)">
          ocultar
          <v-icon>mdi-chevron-up</v-icon>
        </v-btn>
      </template>

      <template v-slot:expanded-item="{ headers, item }">
        <td class="pa-0" :colspan="headers.length">
          <ListaMetaIndividual :items="item.dados" />
        </td>
      </template>
    </BaseTable>
    <ModalCadMetaIndividual
      :dialog="dialog"
      :labelBtn="labelBtn"
      @close="dialog = false"
    />
  </div>
</template>

<script>
import BaseTable from "@/components/shared/NewBaseTable.vue";
import comissao from "@/services/http/comissaoService";
import RegisterBottom from "@/components/shared/bottons/RegisterBottom";
import FilterMetaIndividual from "./FilterMetaIndividual";
import ModalCadMetaIndividual from "./ModalCadMetaIndividual";
import BaseSegmento from "@/components/shared/BaseSegmento";
import ListaMetaIndividual from "./ListaMetaIndividual.vue";

export default {
  components: {
    BaseTable,
    RegisterBottom,
    FilterMetaIndividual,
    ModalCadMetaIndividual,
    BaseSegmento,
    ListaMetaIndividual
  },

  data() {
    return {
      loading: false,
      dialog: false,
      singleExpand: false,
      labelBtn: "",
      expanded: [],
      filters: "",
      headers: [
        { text: "Segmento", value: "id_band" },
        { text: "Empresa", value: "apelido" },
        { text: "Colaborador", value: "colaborador" },
        { text: "Departamento", value: "departamento" },
        { text: "Função", value: "funcao" },
        { text: "QTD Indicadores", value: "qtd_indicadores", align: "center" },
        { text: "Mês Ref", value: "mes_ref" }
      ],
      info: []
    };
  },

  methods: {
    async fetchMetaIndividual(filter) {
      this.loading = true;
      let { data } = await comissao()
        .metaIndividual()
        .show({
          per_page: -1,
          ativo: "S",
          id_tipo_evento: "C",
          id_tipo_dado: "R",
          ...filter
        });
      this.loading = false;
      const obj = this.groupByCompany(data.data, "id_colaborador");
      this.info = Object.values(obj);
    },

    groupByCompany(array, key) {
      return array.reduce((result, currentValue) => {
        (result[currentValue[key]] = result[currentValue[key]] || {
          id_band: currentValue.id_band,
          apelido: currentValue.apelido,
          id_empresa: currentValue.id_empresa,
          nome_empresa: currentValue.nome_empresa,
          id_colaborador: currentValue.id_colaborador,
          departamento: currentValue.departamento,
          funcao: currentValue.funcao,
          colaborador: currentValue.colaborador,
          mes_ref: currentValue.mes_ref,
          ano_ref: currentValue.ano_ref,
          dados: []
        }).dados.push(currentValue);
        return result;
      }, {});
    }
  },

  mounted() {
    if (this.filters != {}) {
      const date = new Date().toISOString().substr(0, 7);
      const [year, month] = date.split("-");
      const filter = {
        ano_ref: parseInt(year),
        mes_ref: parseInt(month)
      };
      this.fetchMetaIndividual(filter);
    }
  }
};
</script>

<style></style>
